module.exports = __webpack_public_path__ + "e686aae8b07ceda85f56ca6ececfddc9.jpg";